const { DateTime, Interval } = require("luxon");

function findSpecialShiftsForNext7Day(shifts, date) {
  return shifts.filter((shift) => {
    let contains = true;
    const startDate = DateTime.fromJSDate(shift.startDate);
    const endDate = DateTime.fromJSDate(shift.endDate);
    if (startDate.isValid && endDate.isValid) {
      const period = date.plus({ days: 6 });
      if (endDate > period) {
        // we only want to show shifts that are within the next 7 days
        contains = false;
      } else {
        const shiftInterval = Interval.fromDateTimes(startDate, endDate);
        const dayInterval = Interval.fromDateTimes(
          date,
          date.plus({ days: 6 })
        );
        contains = dayInterval.overlaps(shiftInterval);
      }
    }
    const dayOfWeekMatch = !shift?.operatingDays
      ? true
      : shift.operatingDays.includes(date.weekdayLong);
    return contains && dayOfWeekMatch;
  });
}

module.exports = function shiftsByType(shifts, date, type) {
  const luxDate = DateTime.fromJSDate(date);
  const shiftsByType = shifts.filter((shift) => shift.type === type);
  return findSpecialShiftsForNext7Day(shiftsByType, luxDate);
};
